var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicEdit", {
    attrs: {
      value: _vm.value,
      "characteristic-items": _vm.meta.skill,
      "characteristic-type": _vm.meta.skillType,
      title: "Soziale Kompetenzen",
      "nothing-allowed": {
        onlyOverall: true,
        overall: {
          text: "Es sind keine sozialen Kompetenzen nötig"
        }
      },
      "selected-items-config": {
        showExperience: false
      },
      "label-set": "customer",
      "label-type": "job-profile"
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }